import { useAsyncData } from 'nuxt/app'
import type { BibleBook, BibleTranslation, Chapter } from '~/types/bible'

export function useBibleTranslations() {
  const nuxtApp = useNuxtApp()
  return useAsyncData<BibleTranslation[]>(`bible-translations`, () => $fetch(`/api/bible/translations/`), {
    getCachedData(key) {
      return nuxtApp.payload.data[key] || nuxtApp.static.data[key]
    },
  })
}

export function useBibleBooks(translation: string) {
  const nuxtApp = useNuxtApp()
  return useAsyncData<BibleBook[]>(`bible-${translation}`, () => $fetch(`/api/bible/${translation}/`), {
    getCachedData(key) {
      return nuxtApp.payload.data[key] || nuxtApp.static.data[key]
    },
  })
}

export function useBibleBook(translation: string, bookCode: string) {
  const nuxtApp = useNuxtApp()
  return useAsyncData<BibleBook>(`${bookCode}-${translation}`, () => $fetch(`/api/bible/${translation}/${bookCode}/`), {
    getCachedData(key) {
      return nuxtApp.payload.data[key] || nuxtApp.static.data[key]
    },
  })
}

export function useBibleChapters(translation: string, bookCode: string) {
  const nuxtApp = useNuxtApp()
  return useAsyncData(
    `${bookCode}-${translation}-chapters`,
    () => $fetch(`/api/bible/${translation}/${bookCode}/chapters/`),
    {
      getCachedData(key) {
        return nuxtApp.payload.data[key] || nuxtApp.static.data[key]
      },
    }
  )
}

export function useBibleChapter(translation: string, bookCode: string, chapterNumber: string) {
  const nuxtApp = useNuxtApp()
  return useAsyncData<Chapter>(
    `${bookCode}-${translation}-${chapterNumber}`,
    () => $fetch(`/api/bible/${translation}/${bookCode}/chapters/${chapterNumber}`),
    {
      getCachedData(key) {
        return nuxtApp.payload.data[key] || nuxtApp.static.data[key]
      },
    }
  )
}
